module.exports = __webpack_public_path__ + "static/media/AjusteEstoque5.e4d9d9a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancAjusteEstoque/AjusteEstoque5.png
// module id = 2053
// module chunks = 0